<template>
    <div>

    </div>
</template>

<script>
    import Scrolling from "../libs/Scrolling"
    import $ from "jquery"

    export default {
        mounted() {
            if ($(".gform_confirmation_wrapper").length > 0) {
                Scrolling.scrollTo(".gform_confirmation_wrapper", "easeInOutExpo", 800, 200)
            }
            if ($(".validation_error").length > 0) {
                Scrolling.scrollTo(".validation_error", "easeInOutExpo", 800, 200)
            }


            if ($("body").hasClass("page-template-contact") && this.$route.query.email) {
                let email = this.$route.query.email
                $("#input_2_5").val(email)

                setTimeout(function () {
                    Scrolling.scrollTo('.form-title', 'easeInOutExpo', 800, 20)
                },500)
            }


        },
    };
</script>
